import EmptyResult from 'component/EmptyResult'
import ComicBox from 'component/ComicBox'
import { useImmer } from 'use-immer'
import { fetchComicBuyList } from 'api'
import { InfiniteScrollCmsGridWrapper, PageScrollWrap } from 'commonStyledComponents'

const Comic = () => {
  const [state, updateState] = useImmer({
    nextPage: 1,
    isLoading: true,
    hasMore: true,
    list: [] as any[],

    page_result: { current: null as any, pageSize: null as any, total: null as any },
  })

  const handleFetchVideoList = () => {
    if (!state.hasMore) return

    const data = {
      current: state.nextPage,
    }

    fetchComicBuyList(data).then((response) => {
      updateState((draft) => {
        draft.list = draft?.list?.concat(response?.data)
        draft.hasMore = response?.page_result?.total > response?.page_result?.current * response?.page_result?.pageSize
        draft.nextPage = response?.page_result?.current + 1
        draft.page_result = response.page_result

        draft.isLoading = false
      })
    })
  }

  return !state?.list?.length && !state.isLoading ? (
    <EmptyResult />
  ) : (
    <PageScrollWrap>
      <InfiniteScrollCmsGridWrapper
        pageStart={0}
        loadMore={handleFetchVideoList}
        hasMore={state?.hasMore}
        // loader={<div className="loader" key={0}>Loading ...</div>}
        useWindow={false}
      >
        {state?.list?.map((item, i) => (
          <ComicBox key={i} comicInfo={item} columns={3}>
            {i}
          </ComicBox>
        ))}
      </InfiniteScrollCmsGridWrapper>
    </PageScrollWrap>
  )
}

export default Comic
